import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import '@polymer/polymer/lib/utils/debounce.js';
import { ModelSharingLink } from '../sharing-link/model-sharing-link';
import { KatapultModel } from '../../modules/katapult-model/KatapultModel.js';
/**
 * `model-loader`
 * Pole application view element
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class ModelLoader extends PolymerElement {
  static get is() {
    return 'model-loader';
  }
  static get properties() {
    return {
      items: {
        type: Array
      },
      companyId: {
        type: String
      },
      observers: {
        type: Object,
        value: () => ({})
      }
    };
  }
  static get observers() {
    return ['getData(items, companyId)'];
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this._tearDownListeners();
  }
  _tearDownListeners() {
    for (const unsubscribe of Object.values(this._unsubscribers ?? {})) {
      unsubscribe?.();
    }
    this._unsubscribers = {};
  }
  async getData(items, companyId) {
    const validUserGroup = this.userGroup && this.userGroup != '_custom_auth';
    //Authenticated links should not update the model space, but if the user is authenticated and there is a company id, we can check if the shared model space is up to date and update it if needed
    if (validUserGroup && companyId) {
      const sharingLinkId = await FirebaseWorker.ref(`photoheight/company_space/${companyId}/sharing_link_id`)
        .once('value')
        .then((s) => s.val());
      const modelOwner = await KatapultModel.fromId(companyId).getModelOwner();
      let upToDate = true;
      let sharingLink;
      let autoUpdate = false;
      // TODO: Only model owners currently have the permission to update a shared model. We should maybe make it so that a 3rd party can update
      // a shared model when accessing the job. But for now since it's not possible, only check for an update if you are the model owner
      if (sharingLinkId && this.userGroup == modelOwner) {
        sharingLink = await FirebaseWorker.ref(`photoheight/company_space/${modelOwner}/sharing_links/model_sharing/${sharingLinkId}`)
          .once('value')
          .then((s) => s.val());
      }
      if (sharingLink) {
        const metadata = sharingLink.metadata || {};
        upToDate = metadata?.up_to_date;
        autoUpdate = metadata?.auto_sync;
      }
      if (!upToDate && autoUpdate) {
        await ModelSharingLink.updateSharedModel({
          linkId: sharingLinkId,
          companyId: modelOwner
        }).catch(() => {
          console.warn('Failed to update shared model space');
        });
      }
    }
    this._tearDownListeners();
    if (items?.length > 0 && companyId) {
      const model = KatapultModel.fromId(companyId);
      items.forEach((item) => {
        const property = this.formatProperty(item);
        if (!this[property]) this._createNotifyingProperty(property);
        this._unsubscribers[property] = model.onModelPathSnapshot(`models/${item}`, (snapshot) => {
          this[property] = snapshot.val();
        });
      });
    } else if (items?.length > 0) {
      items.forEach((item) => {
        this[this.formatProperty(item)] = null;
      });
    }
  }
  formatProperty(str) {
    if (typeof str !== 'string') {
      return str;
    }
    if (str == 'attributes') return 'otherAttributes';
    str = str.replace(/\//g, '_');
    return str
      .replace(/_(.)/g, function (match, group1) {
        return group1.toUpperCase();
      })
      .trim();
  }
  computeItem(property) {
    if (!this.observers[property].initializing && this.observers[property].models.every((x) => typeof x.value != 'undefined')) {
      let data = {};
      this.observers[property].models.forEach((observer) => {
        this.assignData(data, observer.value, property);
      });
      this[property] = data;
    }
  }
  assignData(target, source, property) {
    for (let key in source) {
      if (property == 'buttonGroups' || property == 'inputModelGroups') {
        target[key] = target[key] || {};
        this.assignData(target[key], source[key]);
      } else {
        if (source[key] == '_remove') {
          delete target[key];
        } else {
          target[key] = source[key];
        }
      }
    }
  }
}
window.customElements.define(ModelLoader.is, ModelLoader);
